export default "__VITE_ASSET__954801a6__"